export class Book {
	_id: number;
	title: string;
	author: string;
	year: number;
    country: string;
    borrower: string;

	constructor(obj?: any){
		this._id = obj && obj._id || null;
		this.title = obj && obj.title || null;
		this.author = obj && obj.author || null;
		this.year = obj && obj.year || null;
		this.country = obj && obj.country || null;
		this.borrower = obj && obj.borrower || null;
	}
}